import { useTranslation } from "react-i18next";
import { DisplayedMessages } from "../../../../common/ChatComponents/DisplayedMessages";
import { MessageSendingInput } from "../../../../common/ChatComponents/MessageSendingInput";
import { SendMessageButton } from "../../../../common/ChatComponents/MessageSendingInput/Actions/SendMessageButton";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { AppUnderlinedTitle } from "../../../../shared/components/AppUnderlinedTitle";
import { useMeetingsChat } from "../../hooks/use-meetings-chat";
import {
  selectIsMessageLoading,
  selectMeetingMessages,
} from "../../redux/selectors";
import { ClearButton } from "../../../../common/Components/Buttons/ClearButton";
import styles from "./styles.module.css";
import { MeetingLLMSelections } from "./MeetingLLMSelections";

interface Props {
  className?: string;
}

export const MeetingChat = ({ className }: Props) => {
  const {
    message,
    handleChangeMessage,
    handleSendKeyDown,
    handleSendMessage,
    handleClearChat,
  } = useMeetingsChat();
  const messages = useAppSelector(selectMeetingMessages);
  const isMessageLoading = useAppSelector(selectIsMessageLoading);
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <AppUnderlinedTitle
        leftContent={t("common.chat")}
        rightContentClass={styles["selection"]}
        leftContentClass={styles["left-content-chat"]}
      >
        <MeetingLLMSelections />
        <ClearButton
          typeBtn={"icon_btn"}
          iconType={"broom"}
          onClick={handleClearChat}
          isDisabled={isMessageLoading}
        />
      </AppUnderlinedTitle>
      <div className={styles["meeting-chat"]}>
        <DisplayedMessages
          messages={messages ?? []}
          isLoading={isMessageLoading}
          className={styles.chat}
        />
        <MessageSendingInput
          sendValue={message}
          inputStyle={"elevated"}
          onChange={handleChangeMessage}
          handleKeyDown={handleSendKeyDown}
          actions={<SendMessageButton sendMessage={handleSendMessage} />}
        />
      </div>
    </div>
  );
};
